import React from 'react'

import { useDashboardFeatureFlags } from '@components/utils/DashboardFeatureFlags'
import { SECTION_NAMES } from '@constants/sectionNames'
import { routing } from '@utils/routing'

import { useAnalyticsParams } from '../../modules/AnalyticsParams'
import { AnalyticsOverviewView } from './AnalyticsOverviewView'
import { useAnalyticsOverview } from './hooks/useAnalyticsOverview'
import { useAnalyticsTabs } from './hooks/useAnalyticsTabs'
import { GoogleAnalytics } from './modules/GoogleAnalytics'

export const AnalyticsOverviewContainer = () => {
  const { analyticsParams } = useAnalyticsParams({
    precision: { excluded: ['WEEK', 'MONTH', 'YEAR'] },
  })
  const { analyticsOverview } = useAnalyticsOverview(analyticsParams)
  const { dashboardFeatureFlags } = useDashboardFeatureFlags()
  const tabs = useAnalyticsTabs()

  const toolbarItems = [
    {
      enabled: dashboardFeatureFlags.analyticsTrackingPixels.enabled,
      label: 'Tracking pixels',
      to: routing.analytics.overview.trackingPixels,
    },
  ].filter(({ enabled = true }) => !!enabled)

  return (
    <AnalyticsOverviewView
      title={SECTION_NAMES.analytics}
      toolbarItems={toolbarItems}
      barContent={<GoogleAnalytics />}
      {...tabs}
      profitChart={analyticsOverview.profitChart}
      totalProfitChart={analyticsOverview.totalProfitChart}
      shopProfitChart={analyticsOverview.shopProfitChart}
      membershipsProfitChart={analyticsOverview.membershipsProfitChart}
      membershipsTotalMembersChart={analyticsOverview.membershipsTotalMembersChart}
      membershipsTotalFreeMembersChart={analyticsOverview.membershipsTotalFreeMembersChart}
      membershipsMembersChangeChart={analyticsOverview.membershipsMembersChangeChart}
      membershipsFreeMembersChangeChart={analyticsOverview.membershipsFreeMembersChangeChart}
      contributionsChart={analyticsOverview.contributionsChart}
      shopOrdersChart={analyticsOverview.shopOrdersChart}
      membershipsTransactionsChart={analyticsOverview.membershipsTransactionsChart}
      contributionValueChart={analyticsOverview.contributionValueChart}
      topProductsChart={analyticsOverview.topProductsChart}
      salesByCountryChart={analyticsOverview.salesByCountryChart}
      membershipsTopTiersChart={analyticsOverview.membershipsTopTiersChart}
      paymentMethodUsedChart={analyticsOverview.paymentMethodUsedChart}
      conversionRatesChart={analyticsOverview.conversionRatesChart}
      uniqueVisitorsChart={analyticsOverview.uniqueVisitorsChart}
      salesByTrafficSourceTableChart={analyticsOverview.salesByTrafficSourceTableChart}
      sessionsByTrafficSourceChart={analyticsOverview.sessionsByTrafficSourceChart}
      salesBySocialSourceTableChart={analyticsOverview.salesBySocialSourceTableChart}
      sessionsBySocialSourceChart={analyticsOverview.sessionsBySocialSourceChart}
    />
  )
}
